/**
 * 订阅估价信息
 * 
 * @Author: Focci
 * @Date: 2023-08-17 14:14:47
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-17 14:14:47
 */

'use client'

import PropTypes from 'prop-types'
import useFetch from '@hook/useFetch'
import { CustomDialogWithTitle } from '@comp/dialog/CustomDialog'
import { useCallback, useState } from 'react'
import TrackForm from './track-form'
import TrackSuccess from './TrackSuccess'
import TrackEdit from './track-edit'
import TrackEditSuccess from './TrackEditSuccess'
import TrackSkeletion from './TrackSkeletion'

const Components = {
  form: TrackForm,
  success: TrackSuccess,
  edit: TrackEdit,
  editSuccess: TrackEditSuccess,
}

export default function PropertyTrack({
  hideViewButton,
  propertyId,
  type = 'form'
}) {
  const [param, setParam] = useState({})
  const [step, setStep] = useState(type)
  const { data: property, isLoading } = useFetch(`property/${propertyId}`, null, {
    swrOptions: { revalidateIfStale: true }
  })

  const handleSubmit = useCallback(({ nextStep, param: p }) => {
    setParam(p)
    nextStep && setStep(nextStep)
  }, [])

  if(isLoading) {
    return <TrackSkeletion />
  }

  const Component = Components[step]

  return (
    <Component
      param={param}
      hideViewButton={hideViewButton}
      onSubmit={handleSubmit}
      property={property} 
    />
  )
}

PropertyTrack.propTypes = {
  propertyId: PropTypes.number,
}

export function PropertyTrackDialog({
  hideViewButton,
  propertyId,
  ...dialogProps
}) {
  return (
    <CustomDialogWithTitle {...dialogProps}>
      <PropertyTrack
        hideViewButton={hideViewButton}
        propertyId={propertyId} 
      />
    </CustomDialogWithTitle>
  )
}
